"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const utilities_1 = require("jsAssets/utilities");
const asset_detail_1 = __importDefault(require("jsAssets/views/asset-detail"));
const context_1 = require("jsAssets/views/asset-detail/store/context");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const client_1 = require("react-dom/client");
const includes_1 = __importDefault(require("lodash/includes"));
const get_1 = __importDefault(require("lodash/get"));
const asset_detail_tab_modules_less_1 = __importDefault(require("./asset-detail-tab.modules.less"));
const helper_1 = require("../../reviews/helper");
const AssetPreview = () => {
    const { isLoadingAssetDetail } = (0, react_redux_1.useSelector)((state) => state.assetDetail);
    const { assetDetail } = (0, react_redux_1.useSelector)((state) => state);
    const { reviewRound } = (0, react_redux_1.useSelector)((state) => state.review);
    const isLoadingAsset = !!isLoadingAssetDetail;
    const openAssetDetail = (assetId) => {
        const assetDetailContainer = document.querySelector('#open-asset-detail');
        const assetDetailRoot = assetDetailContainer && (0, client_1.createRoot)(assetDetailContainer);
        window.history.pushState('', '', `#${assetId}`);
        const handleCloseAssetDetail = () => {
            window.history.pushState('', '', `#${(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) || ''}`);
        };
        if (assetDetailRoot) {
            assetDetailRoot.render(react_1.default.createElement(react_1.default.Suspense, { fallback: react_1.default.createElement("div", null, "Loading...") },
                react_1.default.createElement(asset_detail_1.default, { assetId: assetId, onClose: handleCloseAssetDetail })));
        }
    };
    if (isLoadingAsset) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (!Array.isArray(assetDetail === null || assetDetail === void 0 ? void 0 : assetDetail.asset)) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const assets = assetDetail === null || assetDetail === void 0 ? void 0 : assetDetail.asset;
    return (react_1.default.createElement(context_1.AssetDetailProvider, null,
        react_1.default.createElement("p", { className: asset_detail_tab_modules_less_1.default['asset-count'] }, `FILES FOR REVIEW (${assets.length})`),
        react_1.default.createElement("div", { className: asset_detail_tab_modules_less_1.default['asset-items'] }, assets.map((asset) => {
            var _a, _b, _c, _d, _e;
            const isPreviewed = (0, helper_1.hasPreview)(asset) || (asset === null || asset === void 0 ? void 0 : asset.has_preview);
            return isPreviewed ? (react_1.default.createElement(pulse_components_1.PulseGalleryItem, { key: asset === null || asset === void 0 ? void 0 : asset.id, onClick: () => {
                    openAssetDetail(asset === null || asset === void 0 ? void 0 : asset.id);
                }, classes: {
                    root: (0, clsx_1.default)(asset_detail_tab_modules_less_1.default['asset-item__root'], {
                        [asset_detail_tab_modules_less_1.default['asset-item__root--Col']]: (assets === null || assets === void 0 ? void 0 : assets.length) <= 2,
                    }),
                }, CardMediaProps: {
                    classes: {
                        root: asset_detail_tab_modules_less_1.default['asset-item__media'],
                    },
                }, assetThumbnailSrc: `${utilities_1.URLS.pulse}openpreview.php?format=preview&assetid=${asset === null || asset === void 0 ? void 0 : asset.id}`, assetMetaData: {
                    ...asset,
                    job: {
                        label: (_a = asset === null || asset === void 0 ? void 0 : asset.job) === null || _a === void 0 ? void 0 : _a.jobTitle,
                        value: (_b = asset === null || asset === void 0 ? void 0 : asset.job) === null || _b === void 0 ? void 0 : _b.jobId,
                        raw: { ...asset === null || asset === void 0 ? void 0 : asset.job },
                    },
                    client: {
                        ...asset === null || asset === void 0 ? void 0 : asset.client,
                        label: (_c = asset === null || asset === void 0 ? void 0 : asset.client) === null || _c === void 0 ? void 0 : _c.company,
                    },
                    uploadedBy: {
                        ...asset === null || asset === void 0 ? void 0 : asset['uploaded-by'],
                        label: (_d = asset === null || asset === void 0 ? void 0 : asset['uploaded-by']) === null || _d === void 0 ? void 0 : _d.name,
                    },
                } })) : (react_1.default.createElement("img", { className: (0, clsx_1.default)(asset_detail_tab_modules_less_1.default['asset-item__root'], asset_detail_tab_modules_less_1.default['asset-item__root--progress'], Array.isArray(assetDetail === null || assetDetail === void 0 ? void 0 : assetDetail.asset) &&
                    ((_e = assetDetail === null || assetDetail === void 0 ? void 0 : assetDetail.asset) === null || _e === void 0 ? void 0 : _e.length) <= 2 &&
                    asset_detail_tab_modules_less_1.default['asset-item__root--Col']), src: helper_1.processingAsset, alt: asset === null || asset === void 0 ? void 0 : asset.title }));
        }))));
};
const UrlPreview = () => {
    const { reviewRound } = (0, react_redux_1.useSelector)((state) => state.review);
    const isThumbnailLink = !!(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.thumbnailLink);
    const sourceUrl = (0, get_1.default)(reviewRound, 'roundSources[0].url', '');
    const thumbnailUrl = (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.thumbnailLink) || sourceUrl || '';
    const infoUrl = sourceUrl || (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.title) || '';
    const contentURLTooltip = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", null, "WEBSITE/URL:"),
        react_1.default.createElement("span", { className: asset_detail_tab_modules_less_1.default['thumbnail-info__tooltip'] }, sourceUrl))), [sourceUrl]);
    return (react_1.default.createElement("div", { className: asset_detail_tab_modules_less_1.default.preview__url },
        react_1.default.createElement("div", { className: asset_detail_tab_modules_less_1.default['url-thumbnail'] }, isThumbnailLink ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("img", { className: (0, clsx_1.default)(asset_detail_tab_modules_less_1.default['url-thumbnail__img'], asset_detail_tab_modules_less_1.default['url-thumbnail__img--readyUrl']), alt: infoUrl, src: (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.thumbnailLink) || '' }),
            react_1.default.createElement("div", { className: asset_detail_tab_modules_less_1.default['url-thumbnail__info'] },
                react_1.default.createElement("p", { className: asset_detail_tab_modules_less_1.default['thumbnail-info__url'] }, infoUrl),
                react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                        className: asset_detail_tab_modules_less_1.default['thumbnail-tooltip__ctn'],
                        content: contentURLTooltip,
                        placement: 'right',
                    } },
                    react_1.default.createElement("i", { className: "fal fa-info-circle" }))))) : (react_1.default.createElement("div", { className: asset_detail_tab_modules_less_1.default['url-thumbnail__notReady'] },
            react_1.default.createElement("i", { className: (0, clsx_1.default)(asset_detail_tab_modules_less_1.default['notReady-icon'], 'fal fa-browser') }),
            react_1.default.createElement("div", { className: (0, clsx_1.default)(asset_detail_tab_modules_less_1.default['url-thumbnail__info'], asset_detail_tab_modules_less_1.default['url-thumbnail__info--notReady']) },
                react_1.default.createElement("p", { className: asset_detail_tab_modules_less_1.default['thumbnail-info__url'] }, thumbnailUrl),
                react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                        content: contentURLTooltip,
                        placement: 'right',
                    } },
                    react_1.default.createElement("i", { className: "fal fa-info-circle" }))))))));
};
const AssetDetailTab = () => {
    const { reviewRound } = (0, react_redux_1.useSelector)((state) => state.review);
    const isUrlReview = !!(0, includes_1.default)((0, get_1.default)(reviewRound, 'roundSources[0].type'), 'web');
    const isAssetReview = !isUrlReview;
    return (react_1.default.createElement("div", { className: asset_detail_tab_modules_less_1.default['assets-preview'] },
        isAssetReview && react_1.default.createElement(AssetPreview, null),
        isUrlReview && react_1.default.createElement(UrlPreview, null)));
};
exports.default = AssetDetailTab;
